import { createContext } from "react";

import type {
  FrameEditorAction,
  FrameEditorState,
} from "./FrameEditorProvider";
import type { Frame } from "@/types/dragon-tiles";

interface FrameEditorContextValue {
  state: FrameEditorState;
  dispatch: React.Dispatch<FrameEditorAction>;
  handleSave: () => Promise<void>;
  /** Saves the tile and resolves with the server's copy. */
  handleSaveWithFrame: (frame: Frame) => Promise<Frame>;
  isPending: boolean;
  siteId: string;
}

export type { FrameEditorContextValue };

export const FrameEditorContext = createContext<FrameEditorContextValue | null>(
  null,
);
